module.exports = __webpack_public_path__ + "static/media/calendar.4db144d5.svg";